
define('ldsh!modules/page_listing/templates/empty', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-hero ed-hero-modal">\n  <div class="md__general__content__empty mt48">\n    <div>\n      <img alt="contacts"\n        src="https://static.mdirector.com/assets/themes/vEmBlue/globals/src/images/assets/panel-no-content.svg" />\n    </div>\n\n    <h2 class="f24" data-i18n="' +
((__t = ( isEmptyListing() ? 'pageListing.emptySearch' : 'pageListing.text' )) == null ? '' : __t) +
'"></h2>\n\n    <b data-i18n="" class="ed-c-btn ed-c-btn-default ed-overlay-close">\n      <span class="ed-icon ed-icon-close ed-icon-close js-close"></span>\n    </b>\n  </div>\n</div>';

}
return __p
};});

